import {useSelector} from "react-redux";
import {parseISO} from "date-fns";

import {IRPStore} from "../../../app/rp_reducer";
import {calculateGeneralAvgPrices} from "./calculate_general_avg_prices";
import {getCitiesData} from "./get_cities_data";
import {calculatePercent} from "./percents_handling_helpers";

export const usePricesHeaderData = (region?: string) => {
    const pricesData = useSelector((state: IRPStore) => state.report.price.prices);
    const yearAgoData = useSelector((state: IRPStore) => state.report.price.yearAgoPrices);

    if (region && pricesData) {
        const lastMonthData = pricesData && pricesData[pricesData.length - 1];
        const date = lastMonthData && parseISO(lastMonthData.date);
        const month = date && date.toLocaleString("pl-PL", {month: "long"});
        const dateLabel = month && `${month.slice(0, 1).toUpperCase()}${month.slice(1)} ${date.getFullYear()}`;

        const dataToRender = {
            avr_price_m2: {price: lastMonthData.avg_price_m2, percent: calculatePercent(yearAgoData?.avg_price_m2, lastMonthData.avg_price_m2)},
            avr_price: {price: lastMonthData.avg_price, percent: calculatePercent(yearAgoData?.avg_price, lastMonthData.avg_price)},
            offers_count: {count: lastMonthData.available_offers, percent: calculatePercent(yearAgoData?.available_offers, lastMonthData.available_offers)}
        };

        return {dateLabel, dataToRender};
    }

    const citiesData = getCitiesData();

    const date = parseISO(citiesData[0].date);
    const month = date && date.toLocaleString("pl-PL", {month: "long"});
    const dateLabel = month && `${month.slice(0, 1).toUpperCase()}${month.slice(1)} ${date.getFullYear()}`;

    const {allOffers, allOffersOld, generalAvgPrice, generalAvgM2Price, generalAvgPriceOld, generalAvgM2PriceOld} = calculateGeneralAvgPrices(citiesData);

    const dataToRender = {
        avr_price_m2: {price: generalAvgM2Price, percent: calculatePercent(generalAvgM2PriceOld, generalAvgM2Price)},
        avr_price: {price: generalAvgPrice, percent: calculatePercent(generalAvgPriceOld, generalAvgPrice)},
        offers_count: {count: allOffers, percent: calculatePercent(allOffersOld, allOffers)}
    };

    return {dateLabel, dataToRender};
};
import {useSelector} from "react-redux";
import {parseISO} from "date-fns";

import {IRPStore} from "../../../app/rp_reducer";
import {calculateGeneralAvgPrices} from "./calculate_general_avg_prices";
import {getCitiesData} from "./get_cities_data";
import {calculatePercent} from "./percents_handling_helpers";

export const usePricesHeaderData = (region?: string) => {
    const pricesData = useSelector((state: IRPStore) => state.report.price.prices);
    const yearAgoData = useSelector((state: IRPStore) => state.report.price.yearAgoPrices);

    if (region && pricesData) {
        const lastMonthData = pricesData && pricesData[pricesData.length - 1];
        const date = lastMonthData && parseISO(lastMonthData.date);
        const month = date && date.toLocaleString("pl-PL", {month: "long"});
        const dateLabel = month && `${month.slice(0, 1).toUpperCase()}${month.slice(1)} ${date.getFullYear()}`;

        const dataToRender = {
            avr_price_m2: {price: lastMonthData.avg_price_m2, percent: calculatePercent(yearAgoData?.avg_price_m2, lastMonthData.avg_price_m2)},
            avr_price: {price: lastMonthData.avg_price, percent: calculatePercent(yearAgoData?.avg_price, lastMonthData.avg_price)},
            offers_count: {count: lastMonthData.available_offers, percent: calculatePercent(yearAgoData?.available_offers, lastMonthData.available_offers)}
        };

        return {dateLabel, dataToRender};
    }

    const citiesData = getCitiesData();

    const date = parseISO(citiesData[0].date);
    const month = date && date.toLocaleString("pl-PL", {month: "long"});
    const dateLabel = month && `${month.slice(0, 1).toUpperCase()}${month.slice(1)} ${date.getFullYear()}`;

    const {allOffers, allOffersOld, generalAvgPrice, generalAvgM2Price, generalAvgPriceOld, generalAvgM2PriceOld} = calculateGeneralAvgPrices(citiesData);

    const dataToRender = {
        avr_price_m2: {price: generalAvgM2Price, percent: calculatePercent(generalAvgM2PriceOld, generalAvgM2Price)},
        avr_price: {price: generalAvgPrice, percent: calculatePercent(generalAvgPriceOld, generalAvgPrice)},
        offers_count: {count: allOffers, percent: calculatePercent(allOffersOld, allOffers)}
    };

    return {dateLabel, dataToRender};
};
